import { createAction } from '@reduxjs/toolkit'

import { TReport, TReportBlock, TResourceFilter } from 'types/GlobalReport'
import { TReportWidget } from 'types/GlobalWidget'

// tryGetAllReports
export const getAll = createAction('get_all_reports')
export const getAllSuccess = createAction<TReport[]>('get_all_reports_success')
export const getAllFailed = createAction('get_all_reports_failed')

// tryCreateReport
export const create = createAction('create_report')
export const createSuccess = createAction<TReport>('create_report_success')
export const createFailed = createAction('create_report_failed')

// tryDeleteReport
export const destroy = createAction('delete_report')
export const destroySuccess = createAction<string>('delete_report_success')
export const destroyFailed = createAction('delete_report_failed')

// tryUpdateReport
export const update = createAction('update_report')
export const updateSuccess = createAction<TReport>('update_report_success')
export const updateFailed = createAction('update_report_failed')

// tryGetReportTemplateBlocks
export const getTemplateBlocks = createAction<string>(
  'get_report_template_blocks'
)
export const getTemplateBlocksSuccess = createAction<{
  reportId: string
  blocks: TReportBlock[]
}>('get_report_template_blocks_success')
export const getTemplateBlocksFailed = createAction<string>(
  'get_report_template_blocks_failed'
)

// tryGetReportEditionBlocks
export const getEditionBlocks = createAction<string>(
  'get_report_edition_blocks'
)
export const getEditionBlocksSuccess = createAction<{
  editionId: string
  blocks: TReportBlock[]
}>('get_report_edition_blocks_success')
export const getEditionBlocksFailed = createAction<string>(
  'get_report_edition_blocks_failed'
)

// tryReorderBlocks
export const reorderBlocks = createAction('reorder_report_blocks')
export const reorderBlocksSuccess = createAction<{
  reportId: string
  order: string[]
}>('reorder_report_blocks_success')
export const reorderBlocksFailed = createAction('reorder_report_blocks_failed')

// tryReorderBlockWidgets
export const reorderBlockWidgets = createAction('reorder_report_block_widgets')
export const reorderBlockWidgetsSuccess = createAction<{
  reportId: string
  blockId: string
  order: string[]
}>('reorder_report_block_widgets_success')
export const reorderBlockWidgetsFailed = createAction(
  'reorder_report_block_widgets_failed'
)

// tryPutReportFilters
export const putFilters = createAction('put_report_filters')
export const putFiltersSuccess = createAction<{
  reportId: string
  filters: TResourceFilter[]
}>('put_report_filters_success')
export const putFiltersFailed = createAction('put_report_filters_failed')

// tryCopyReport
export const copyReport = createAction('copy_report')
export const copyReportSuccess = createAction<TReport>('copy_report_success')
export const copyReportFailed = createAction('copy_report_failed')

// tryVisitReport
export const visitReport = createAction<string>('visit_report')
export const visitReportSuccess = createAction<string>('visit_report_success')
export const visitReportFailed = createAction('visit_report_failed')

// tryCreateReportWidget --> TODO: move to widget action
export const createWidget = createAction('create_report_widget')
export const createWidgetSuccess = createAction<{
  block: TReportBlock
  widget: TReportWidget
}>('create_report_widget_success')
export const createWidgetFailed = createAction('create_report_widget_failed')
